// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__n90Oe","cell":"ColumnAccessor_cell__NDU1N","firstCellAccent":"ColumnAccessor_firstCellAccent__p2n4i"};